import script from "./list.vue?vue&type=script&lang=js&setup=true"
export * from "./list.vue?vue&type=script&lang=js&setup=true"

import "./list.vue?vue&type=style&index=0&id=94be81de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94be81de"]])

export default __exports__